// Shared number-formatting helpers for the Forecast DRV table.
// Adds thousands separators (e.g. "100,000") to every numeric field
// except Forecasted Temperature.

export const formatThousands = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value).trim();
  if (str === "") return "";

  const isNegative = str.startsWith("-");
  const digitsOnly = str.replace(/[^0-9]/g, "");
  if (digitsOnly === "") return isNegative ? "-" : "";

  const formatted = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return isNegative ? `-${formatted}` : formatted;
};

export const stripCommas = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/,/g, "");
};